// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const authSsoStartApiAuthSsoGetParamsNextOneMax = 2000;

export const AuthSsoStartApiAuthSsoGetParams = zod.object({
  "next": zod.union([zod.string().max(authSsoStartApiAuthSsoGetParamsNextOneMax),zod.null()]).optional()
})

export type AuthSsoStartApiAuthSsoGetParams = zod.input<typeof AuthSsoStartApiAuthSsoGetParams>;
export type AuthSsoStartApiAuthSsoGetParamsOutput = zod.output<typeof AuthSsoStartApiAuthSsoGetParams>;
